import { createBrowserHistory } from 'history';
import { ROUTE_PATHS } from './routes';

const history = createBrowserHistory();

history.listen(location => {
  console.log(location.pathname);
  setTimeout(() => {
    if (location.pathname === ROUTE_PATHS.ACTIVE_AUCTIONS) return;
    if (/Edge/.test(navigator.userAgent)) {
      window.scrollTop(0);
    } else {
      window.scrollTo(0, 0);
    }
  });
});

export { history };
